export default {
	PARENT_LAYOUTS: 'Parent layouts:',
	REORDER_TILE_LAYOUT_TILES: 'Reorder tile layout tiles',
};
